$(function () {
'use strict';

//////////////////////////////////////////////////////////////////////////////////////
//
// V A R I A B L E S
//
//////////////////////////////////////////////////////////////////////////////////////

var $fn = {},
    $el = {
        window: $(window),
        html: $('html'),
        body: $('body'),
        document: $('.l-document'),
        recruitSlide: ''
    },
    param = {
        winW        : window.innerWidth || $el.window.width(),
        winH        : window.innerHeight || $el.window.height(),
        docW        : $el.document.outerWidth(),
        docH        : $el.document.outerHeight(),
        path:'',
       center_coordinates:'',
        text:'',
        text2:'',
        category:'',
        switch_flg:''

    };
    var bodyObj = $('body');
    bodyObj.append('<div class="loading-logo"><div class="loading-logo--inner"><figure><img src="assets/images/mark_about.svg"></figure></div></div>');




    $fn.naviToggle = function () {
        $('.toggle').on('click', function(event) {
            event.preventDefault();
            param.switch_flg = $("body").hasClass("open");
            if(param.switch_flg){
                $('body').removeClass('open');

            }else{
                $('body').addClass('open');
            }
        });
    };
    $fn.naviToggle();

    $('.l-section--second-gallery--inner li').on('click',function () {
        param.path = $('img',this).attr('src');

    });

    $('.product-ul li').on('click',function () {
        param.path = $('img',this).attr('src');
        param.text = $('.name',this).html();
        if($('.text',this).html()) {
            param.text2 = $('.text', this).html();
        }else{
            param.text2 = '';
        }
        param.category = $(this).attr('data-category');
    });
    $(document).on('opening', '.remodal', function () {
        $('img',this).attr('src',param.path);
        $('.name',this).html(param.text);
        $('.category',this).text(param.category);
        $('.text',this).text(param.text2);
    });
    $fn.googlemaps = function () {
        if ($('#map').length) {
            var coordinates = {
                lat: 35.17354,
                lng: 136.914701
            };
            if (param.winW <= 768) {
                param.center_coordinates = {
                    lat: 35.17354,
                    lng: 136.914701
                };
            }else{
                param.center_coordinates = {
                    lat: 35.17354,
                    lng: 136.9284769
                };
            }

            var zoom;

            if (param.winW <= 750) {
                zoom = 15;
            } else {
                zoom = 15;
            }

            var maps = new GMaps({
                div: '#map',
                zoom: zoom,
                lat: param.center_coordinates.lat,
                lng: param.center_coordinates.lng,
                scrollwheel: false,
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                overviewMapControl: false,
                resize: function () {
                    this.setCenter(param.center_coordinates);
                }

            });

            maps.addMarker({
                lat: coordinates.lat,
                lng: coordinates.lng,
            });



                var styles = [
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -120
                        },
                        {
                            "gamma": 1.0
                        }
                    ]
                }
            ];
            maps.addStyle({
                styledMapName: "Styled Map",
                styles: styles,
                mapTypeId: "map_style"
            });

            maps.setStyle("map_style");
        }

    };
    $fn.googlemaps();

    $el.window.resize('load', function () {
        param.winW = window.innerWidth || $el.window.width();
        if (param.winW <= 768) {
            param.center_coordinates = {
                lat: 35.164975,
                lng: 136.912147
            };
        }else{
            param.center_coordinates = {
                lat: 35.164975,
                lng: 136.928147
            };
        }
    });


    $(document).on('opening', '.remodal', function () {
        $('img',this).attr('src',param.path);
    });

    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 500,
        speedAsDuration: true
    });


    var url = document.location.href;
    var parameter = document.location.search;
    $('.link a').on('click','',function (e) {
        e.preventDefault();
        var path = $(this).attr("href");
        $('body').removeClass('loaded');
        $('body').addClass('loading');
        setTimeout(function(){
            if(parameter){
                window.location.href = path+parameter;
            }else{
                window.location.href = path;

            }
        }, 1000);

    });

    //言語切替

    $fn.lang_switch = function () {
        var json_common = 'assets/lang/common.json';

        if(url.indexOf("about") !== -1){
            var json = 'assets/lang/about.json';
        }else if(url.indexOf("product") !== -1){
            var json = 'assets/lang/product.json';
        }else if(url.indexOf("html") === -1 || url.indexOf("index") !== -1){
            var json = 'assets/lang/index.json';
        }
        if (url.indexOf('lang=jp') !== -1 && url.indexOf('?') !== -1) {
            $('.en_a').each(function(){
                $(this).css('display','none');
            });

            $.getJSON(json, function (data) {
                for (var i in data) {
                    $(data[i].id).html('');
                    $(data[i].id).html(data[i].jp);
                }
            })
            $.getJSON(json_common, function (data2) {
                for (var j in data2) {
                    $([data2[j].id]).html('');
                    $([data2[j].id]).html(data2[j].jp);
                }
            })
        }else if (url.indexOf('lang=en') !== -1) {
            $('.en_a').each(function(){
                $(this).css('display','block');
            });
            $('.en_h').each(function(){
                $(this).css('display','none');
            });
            $('.g_dl').each(function(){
                $(this).attr('href','assets/files/outline_en.pdf')
            });



            $.getJSON(json, function (data) {
                for (var i in data) {
                    $(data[i].id).html('');
                    $(data[i].id).html(data[i].en);
                }
            })
            $.getJSON(json_common, function (data2) {
                for (var j in data2) {
                    var data_id = data2[j].id;
                    data_id = data_id.slice( 1 ) ;
                    data_id = "[id="+ data_id +"]";
                    console.log(data_id);
                    $(data_id).html('');
                    $(data_id).html(data2[j].en);
                }
            })
        }


    };

    $fn.lang_switch();




    if (url.indexOf('lang=jp') !== -1 || url.indexOf('?') === -1) {
        $('#lang-en').removeClass('active');
        $('#lang-jp').addClass('active');
    }else if (url.indexOf('lang=en') !== -1) {
        $('#lang-jp').removeClass('active');
        $('#lang-en').addClass('active');
    }

    $(document).on('click','#lang-jp',function (e) {
        url = document.location.href;
        if (url.indexOf('lang=jp') === -1 && url.indexOf('?') !== -1) {
            url = url.replace(/\?.*$/,"");
            url = url + "?lang=jp";
            $('body').removeClass('loaded');
            $('body').addClass('loading');
            setTimeout(function(){
                document.location = url;
            }, 1000);
        }
    });

    $(document).on('click','#lang-en',function (e) {
        url = document.location.href;
        if (url.indexOf('lang=en') === -1) {
            $('#lang-jp').removeClass('active');
            $('#lang-en').addClass('active');
            url = url.replace(/\?.*$/,"");
            url = url + "?lang=en";
            $('body').removeClass('loaded');
            $('body').addClass('loading');
            setTimeout(function(){
                document.location = url;
            }, 1000);
        }
    });

    if($('.l-section--news').length) {
        var $container_fb = $('.l-section--news ul');

        $.getJSON("./inc/fb_feed.php", function(fb_data){

            var post_data = fb_data["posts"]["data"];

            var html_fb = [];
            var maxLength = 3;
            var leng = post_data.length

            for (var j = 0;(j < leng) && (j < maxLength); j++) {

                if (post_data[j].message) {

                    var time = post_data[j].created_time;
                    time = new Date(time.replace(/([\+|\-])([0-9]{2})([0-9]{2})$/,"$1$2:$3"));

                    var year = time.getFullYear();
                    var month = time.getMonth() + 1;
                    var day = time.getDate();
                    time = year + '.' + month + '.' + day;
                    var count = 45;
                    var thisText = post_data[j].message;
                    var textLength = thisText.length;
                    var insertText;
                    if (textLength > count) {
                        var showText = thisText.substring(0, count);
                        insertText = showText += '…';

                    }else{
                        insertText = thisText;
                    }

                    html_fb.push('<li><a href="' + post_data[j].permalink_url + '" target="_blank"><span class="day">' + time + '</span><span class="text">' + insertText + '</span></a></div>');
                }
            }
            $container_fb.html(html_fb.join(''))

        });
    };

    if($('.l-section--instagram-feed').length) {
        var $container = $('.l-section--instagram-feed ul');

        $.getJSON("./inc/feed.php", function(instagram_data){

            var gallery_data = instagram_data["media"]["data"];

            var html = [];
            var maxLength = 12;

            for (var i = 0, len = gallery_data.length; (i < len) && (i < maxLength); i++) {
                html.push('<li><a href="'+ gallery_data[i].permalink +'" target="_blank"><img src="' + gallery_data[i].media_url + '"></a></div>');
            }
            $container.html(html.join(''))

        })
    };

    sal({
        threshold: .5,
        once: true,
    });





});

$(window).on('load',function(){


    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $('.l-document'),
            mousepos     : $('.js-action-mousepos'),
            recruitSlide : ''
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            flkty       : '',
            flkty2      : ''
        };

    var bodyObj = $('body');
    bodyObj.addClass('loaded');


    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var $head_height = $('.l-header').innerHeight();
        var $target_height = param.winH-$head_height*2;

        var ratio = 0.56;

        var mainImgW = $('.main-carousel .carousel-cell img').width();


        $target.css({
            height:$target_height+'px'
        })
    };
    $fn.indexSlider = function() {
        if ($('.main-carousel').length) {
            // var total = $('.main-carousel .carousel-cell').length;
            // total = '0'+total;
            // $('.main-carousel-num .right').text(total);

            var carousel = document.querySelector('.main-carousel');
            param.flkty = new Flickity(carousel, {
                imagesLoaded: true,
                percentPosition: false,
                autoPlay: 4000,
                contain: true,
                prevNextButtons : false,
                pageDots: false,
                wrapAround: true,
                fade:true
            });

            var $carousel = $('.main-carousel').flickity();

            // $('.main-carousel-arrow .left').on( 'click', function() {
            //     $carousel.flickity( 'previous', true );
            // });
            //
            // $('.main-carousel-arrow .right').on( 'click', function() {
            //     $carousel.flickity('next', true );
            // });
        }

    };
    $fn.indexSlider();



});